/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.time-dialog {
  form {
    width: 20%;
    min-width: 300px;
    max-width: 500px;
  }

  .centered {
    margin-top: variables.$margin-medium;
    .MuiInputBase-root .MuiInputBase-input {
      text-align: center;
    }
  }

  .small-time {
    width: 180px;
  }
}
